import { useMemo } from 'react';

import image1 from '../assets/1.webp';
import image2 from '../assets/2.webp';
import image3 from '../assets/3.webp';
import image4 from '../assets/4.webp';
import image5 from '../assets/5.webp';

const images = [image1, image2, image3, image4, image5];

function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const useUpsellImageUrl = () => {
  const image = useMemo(() => {
    const randomIndex = randomIntFromInterval(0, images.length - 1);

    return images[randomIndex];
  }, []);

  return image;
};

export default useUpsellImageUrl;
